import { configureStore } from '@reduxjs/toolkit'
import { listenerMiddleware } from './listenerMiddleware'
import reducer from '../slices/index'

const store = configureStore({
  reducer: reducer,
  middleware: getDefaultMiddleWare =>
    getDefaultMiddleWare({ serializableCheck: false }).prepend(
      listenerMiddleware.middleware
    ),
  devTools: import.meta.env.NODE_ENV !== 'production'
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type GetState = typeof store.getState
